import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Asset } from '../../../common/generated-types';
import { AboutFormData, TitleInfo } from '../../../common/interfaces';

@Component({
    selector: 'vsf-about-form',
    templateUrl: './about-form.component.html',
    styleUrls: ['./about-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AboutFormComponent implements OnInit {
    @Input() aboutForm: AboutFormData;
    @Input() isMobile: boolean | null;
    @Input() linePadding: string;
    @Input() titleInfo: TitleInfo | null = null;

    text: string;
    citation: string;
    featuredAsset: Asset;

    constructor() { }

    ngOnInit(): void {
        if(this.aboutForm) {
            this.text = this.aboutForm.text || this.text;
            this.citation = this.aboutForm.citation || this.citation;
            this.featuredAsset = this.aboutForm.featuredAsset || this.featuredAsset;
        }
    }
}
